import { Flex, Typography } from 'antd';
import Lottie from 'react-lottie';
import { string } from 'prop-types';

import styles from './UpdatingState.less';
import * as loadingGif from './loading.json';

const { Text } = Typography;

const UpdatingState = ({ clinicName }) => {
  return (
    <Flex vertical align="center" justify="center" className={styles.wrapper}>
      <Flex vertical align="center" justify="center" gap={24}>
        <Lottie
          options={{
            loop: true,
            autoplay: true,
            animationData: loadingGif.default,
          }}
          height={100}
          width={100}
        />
        <Flex vertical align="center" justify="center" gap={12}>
          <Text>Switching to:</Text>
          <Text className={styles.clinicName}>{clinicName}</Text>
        </Flex>
      </Flex>
    </Flex>
  );
};

UpdatingState.propTypes = {
  clinicName: string.isRequired,
};

export default UpdatingState;
